module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-chalk-1-6015c1217634161b01931d1293cf9d8c.webp";